import { gql } from "@apollo/client";
import { BANNER_FIELDS } from "./query";

export const CREATE_BANNER = gql`
  mutation CreateBanner($input: CreateBannerInput!) {
    banner {
      createBanner(input: $input) {
        ...BannerFields
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;

export const UPDATE_BANNER = gql`
  mutation UpdateBanner($id: ID!, $input: UpdateBannerInput!) {
    banner {
      updateBanner(id: $id, input: $input) {
        ...BannerFields
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;

export const SWITCH_BANNER_STATUS = gql`
  mutation SwitchBannerStatus($id: ID!, $isActive: Boolean!) {
    banner {
      switchBannerStatus(id: $id, isActive: $isActive) {
        id
        isActive
        __typename
      }
      __typename
    }
  }
`;

export const SAVE_BANNER_QUEUE = gql`
  mutation SaveBannerQueue($input: SaveBannerQueueInput!) {
    banner {
      saveBannerQueue(input: $input) {
        banner {
          ...BannerFields
        }
        queuePosition
        isActive
        __typename
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;
